import { Extension } from '@tiptap/core';
import { Node as PMNode } from 'prosemirror-model';
import { EditorState, Plugin } from 'prosemirror-state';
import { CellSelection } from 'prosemirror-tables';
import { Decoration, DecorationSet } from 'prosemirror-view';

export const CellSelectionExtension = Extension.create({
  name: 'cellSelectionExtension',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          decorations(state: EditorState) {
            const { selection } = state;
            if (!(selection instanceof CellSelection)) {
              return DecorationSet.empty;
            }
            const decorations: Decoration[] = [];
            (selection as CellSelection).forEachCell((cell: PMNode, pos: number) => {
              decorations.push(
                Decoration.node(pos, pos + cell.nodeSize, { class: 'cell-selected' }),
              );
            });
            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});

export default CellSelectionExtension;
